export const Footer = () => (
  <footer className="app-footer">
    <span className="footer-legal">
      Copyright © 2026{' '}
      <a href="https://www.etsy.com/shop/AduanStudio" target="_blank" rel="noopener noreferrer">Aduan Studio</a>
      . This dashboard is for personal use only. Redistribution or resale of this code is prohibited by law.
    </span>
  </footer>
);
